import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { of, switchMap, take } from 'rxjs';

import { AuthService } from '@user/services/auth.service';
import { Button } from "primeng/button";
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { Message } from "primeng/message";
import { PasswordModule } from 'primeng/password';
import { TranslatePipe } from '@ngx-translate/core';
import { passwordMatchValidator } from '@shared/helpers/password-match.validator';

@Component({
    selector: 'app-change-password-modal',
    imports: [
        InputTextModule,
        PasswordModule,
        FormsModule,
        ReactiveFormsModule,
        TranslatePipe,
        Button,
        Message
    ],
    templateUrl: './change-password-modal.component.html',
    styleUrl: './change-password-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePasswordModalComponent {
    private fb = inject(FormBuilder);
    private authService = inject(AuthService);
    private dynamicDialogRef = inject(DynamicDialogRef);

    form: FormGroup;

    constructor() {
        this.form = this.fb.group(
            {
                oldPassword: ['', [Validators.required, Validators.minLength(6)]],
                password: ['', [Validators.required]],
                passwordRepeat: ['', [Validators.required]],
            },
            { validators: passwordMatchValidator('password', 'passwordRepeat') },
        );
    }

    submitClicked(): void {
        const userEmail = this.authService.user()?.email;
        if (userEmail) {
            this.authService
                .login(userEmail, this.form.get('oldPassword')?.value)
                .pipe(
                    switchMap((isError: string | null) => {
                        return isError
                            ? of(isError)
                            : this.authService.updateUserPassword(this.form.get('password')?.value);
                    }),
                    take(1),
                )
                .subscribe(() => {
                    this.closeModal();
                });
        }
    }

    closeModal(): void {
        this.dynamicDialogRef.close();
    }
}
